import React, { useState, useRef, useCallback, useMemo } from 'react';
import AntLocalization from '../../utils/AntLocalization';

// ─── Tooltip ──────────────────────────────────────────────────
function BlockTooltip({ item, tooltipFields, statusColors, position }) {
    if (!item) return null;

    var style = {
        position: 'fixed',
        left: position.x,
        top: position.y,
        zIndex: 9999
    };

    return (
        <div className="timeline-block-tooltip" style={style}>
            {tooltipFields.map(function (field, idx) {
                var val = item[field.dataField];
                if (val == null || val === '') return null;
                var label = field.label ? AntLocalization.translateText(field.label) : field.dataField;
                return (
                    <div key={idx} className="tooltip-row">
                        <span className="tooltip-label">{label}</span>
                        <span className="tooltip-value">{String(val)}</span>
                    </div>
                );
            })}
            {item._statusLabel && (
                <div className="tooltip-status">
                    <span
                        className="tooltip-status-dot"
                        style={{ background: statusColors[item._statusValue] || '#999' }}
                    />
                    <span>{item._statusLabel}</span>
                </div>
            )}
        </div>
    );
}

// ─── Main Block Component ─────────────────────────────────────
export default function TimelineBlock(props) {
    var {
        item,
        left,
        width,
        statusColors,
        displayField,
        secondaryField,
        tooltipFields,
        onClick,
        cellHeight
    } = props;

    var [showTooltip, setShowTooltip] = useState(false);
    var [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
    var blockRef = useRef(null);

    var statusValue = item._statusValue || '';
    var bgColor = (statusColors && statusColors[statusValue]) || '#7c8db5';

    var displayText = item[displayField] || '';
    var secondaryText = secondaryField ? (item[secondaryField] || '') : '';

    var handleMouseEnter = useCallback(function (e) {
        if (tooltipFields && tooltipFields.length > 0) {
            var rect = e.currentTarget.getBoundingClientRect();
            setTooltipPos({ x: rect.left, y: rect.bottom + 4 });
            setShowTooltip(true);
        }
    }, [tooltipFields]);

    var handleMouseLeave = useCallback(function () {
        setShowTooltip(false);
    }, []);

    var handleClick = useCallback(function (e) {
        e.stopPropagation();
        if (onClick) onClick(item);
    }, [onClick, item]);

    var blockStyle = useMemo(function () {
        return {
            left: left + '%',
            width: Math.max(width, 0.5) + '%',
            background: bgColor,
            height: cellHeight ? (cellHeight - 8) + 'px' : undefined
        };
    }, [left, width, bgColor, cellHeight]);

    // Narrow block — chỉ hiện chữ nếu đủ rộng
    var isNarrow = width < 8;

    return (
        <React.Fragment>
            <div
                ref={blockRef}
                className={'timeline-block' + (onClick ? ' clickable' : '') + (isNarrow ? ' narrow' : '')}
                style={blockStyle}
                onClick={handleClick}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                title={isNarrow ? displayText : undefined}
            >
                {!isNarrow && (
                    <div className="block-content">
                        <span className="block-text">{displayText}</span>
                        {secondaryText && <span className="block-secondary">{secondaryText}</span>}
                    </div>
                )}
            </div>
            {showTooltip && (
                <BlockTooltip
                    item={item}
                    tooltipFields={tooltipFields}
                    statusColors={statusColors}
                    position={tooltipPos}
                />
            )}
        </React.Fragment>
    );
}
